import { useEffect, useState } from "react";

import { useTranslation } from "../CustomHooks/useTranslation";

import styles from "./BrowserCheck.module.scss";

interface IBrowserCheckProps {
    chromeMinimumVersion: number;
    edgeMinimumVersion: number;
    firefoxMinimumVersion: number;
    safariMinimumVersion: number;
}

function BrowserCheck(props: IBrowserCheckProps): JSX.Element {
    const { getText } = useTranslation();
    const [isChromeOutdated, setIsChromeOutdated] = useState(false);
    const [isEdgeOutdated, setIsEdgeOutdated] = useState(false);
    const [isFirefoxOutdated, setIsFirefoxOutdated] = useState(false);
    const [isSafariOutdated, setIsSafariOutdated] = useState(false);

    useEffect(() => {
        const isEdge = !!navigator.userAgent.toLowerCase().contains("edg");
        const browser = isEdge ? "" : navigator.userAgent.match(/Chrome\/(\d+)/);
        const version = browser ? parseInt(browser[1], 10) : 0;

        if (version > 0 && version < props.chromeMinimumVersion) {
            setIsChromeOutdated(true);
        }
    }, [props.chromeMinimumVersion]);

    useEffect(() => {
        const browser = navigator.userAgent.match(/Edg\/(\d+)/);
        const version = browser ? parseInt(browser[1], 10) : 0;

        if (version > 0 && version < props.edgeMinimumVersion) {
            setIsEdgeOutdated(true);
        }
    }, [props.edgeMinimumVersion]);

    useEffect(() => {
        const browser = navigator.userAgent.match(/Firefox\/(\d+)/);
        const version = browser ? parseInt(browser[1], 10) : 0;

        if (version > 0 && version < props.firefoxMinimumVersion) {
            setIsFirefoxOutdated(true);
        }
    }, [props.firefoxMinimumVersion]);

    useEffect(() => {
        const browser = navigator.userAgent.match(/Version\/(\d+)/);
        const version = browser ? parseInt(browser[1], 10) : 0;

        if (version > 0 && version < props.safariMinimumVersion) {
            setIsSafariOutdated(true);
        }
    }, [props.safariMinimumVersion]);

    if (!isChromeOutdated && !isEdgeOutdated && !isFirefoxOutdated && !isSafariOutdated) {
        return null;
    }

    return (
        <div>
            <p>{getText("BrowserOutOfDateLabel")} {getText("UpdateBrowserLabel")}</p>
            {isChromeOutdated && (
                <a
                    href="https://www.google.com/chrome/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.link}
                >
                    {getText("UpdateChromeLabel")}
                </a>
            )}
        </div>
    );
}

export { BrowserCheck };
